// extracted by mini-css-extract-plugin
module.exports = {"label":"CodeLabel_label__O5Otv"};